import React from "react";
import { PageHeader, CardItem } from "../Components";
import get_sub_categories_post from "actions/get_sub_categories_post";
import get_sub_category from "actions/get_sub_category";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { baseUrl } from "env";
class Comp extends React.PureComponent {
  async componentDidMount() {
    await this.props.get_sub_categories_post({
      category: this.props.match.params.category,
      sub_category: this.props.match.params.sub_category
    });
    await this.props.get_sub_category({
      url: this.props.match.params.sub_category
    });
  }
  render = () => (
    <div>
      <PageHeader
        backgroundUrl={`${baseUrl}/api/media/media/${this.props.sub_category.cover_media_id}`}
        headerClass={this.props.match.params.category.split("-").join("_")}
        pageName={`${this.props.sub_category.title}`}
      />
      <div className="container mt80 mb80">
        {this.props.sub_categories_post
          ? this.props.sub_categories_post.map((item, key) => (
              <CardItem
                id={item.id}
                thumbnail={`${baseUrl}/api/media/media/${item.cover_media_id}`}
                key={key}
                col={4}
                title={item.title}
              />
            ))
          : ""}
      </div>
    </div>
  );
}
const mapStateToProps = state => ({
  sub_categories_post: state.sub_categories_post
    ? state.sub_categories_post.data
    : [],
  sub_category: state.sub_category ? state.sub_category.data : []
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      get_sub_categories_post,
      get_sub_category
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Comp);
